import { FunctionComponent, useEffect } from "react";
import { FieldErrors, useForm, UseFormRegister } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  RadioGroupWithRegister,
  TextInputWithRegister,
} from "src/components/inputs";
import { NEATTOptions, userTypes } from "src/utils/types";
import { analysis, dynamo, format, forms, sendgrid } from "src/utils";
import { Button } from "src/components/generic";
import { useAuth } from "src/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { ToastStatus, useToast } from "src/context/ToastContext";
import { INote } from "src/utils/types/NoteTypes";

interface IFinancialKnowledgeFormProps {
  register: UseFormRegister<any>;
  errors: FieldErrors;
  saving?: string;
}

const FinancialKnowldgeForm: FunctionComponent<IFinancialKnowledgeFormProps> = ({ register, errors, saving }) => (
  <form className="grid grid-cols-3 gap-4">
    <RadioGroupWithRegister
      containerStyles="mb-6 lg:mb-0"
      question="Are you familiar with your current debt-to-income ratio?"
      name="familiarWithD2I"
      register={register}
      options={NEATTOptions.YesNoUnsureOptions}
      error={`${errors?.familiarWithD2I?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Do you have a budget or financial plan in place?"
      name="financialPlanInPlace"
      register={register}
      options={NEATTOptions.YesNoOptions}
      containerStyles="mb-6 lg:mb-0"
      error={`${errors?.financialPlanInPlace?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="How would you describe your financial knowledge and experience?"
      name="experienceLevel"
      register={register}
      options={NEATTOptions.NoneToExcllentRange}
      containerStyles="mb-6 lg:mb-0"
      error={`${errors?.experienceLevel?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Have you attended any financial education courses or workshops?"
      name="attendedCoursesOrWorkshops"
      register={register}
      options={NEATTOptions.YesNoOptions}
      containerStyles="mb-6 lg:mb-0"
      error={`${errors?.attendedCoursesOrWorkshops?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Have you ever worked with a financial advisor?"
      name="workedWithAdvisor"
      register={register}
      options={NEATTOptions.YesNoOptions}
      containerStyles="mb-6 lg:mb-0"
      error={`${errors?.workedWithAdvisor?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Have you used any financial management tools or apps?"
      name="usingToolsOrApps"
      register={register}
      options={NEATTOptions.YesNoOptions}
      containerStyles="mb-6 lg:mb-0"
      error={`${errors?.usingToolsOrApps?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Are you saving for retirement?"
      name="savingForRetirement"
      register={register}
      options={NEATTOptions.YesNoOptions}
      containerStyles="mb-6 lg:mb-0"
      error={`${errors?.savingForRetirement?.message || ""}`}
    />

    {saving === NEATTOptions.YesNoUnsure.YES && (
      <TextInputWithRegister
        register={register("amountPerMonth")}
        label="Amount Per Month"
        id="amountPerMonth"
        placeholder="00.00"
        error={errors?.amountPerMonth?.message}
      />
    )}
  </form>
);

export default FinancialKnowldgeForm;
